import React, { useEffect, useRef } from 'react';

import L from 'leaflet';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import 'leaflet.awesome-markers';

import { Marker } from 'react-leaflet';

import ReactDOMServer from 'react-dom/server';
import theme from 'v3/theme';
import MarkerContainer from './styles';
import Text from '../../Text';

export default function MarkerMap({ background = theme.colors.primary, position, text, color, onClose }) {
  const markerRef = useRef(null);

  useEffect(() => {
    const element = markerRef.current?.getElement?.();
    const closeButton = element?.querySelector?.('.marker-map-close');

    if (!closeButton) return undefined;

    const handleCloseClick = (event) => {
      L.DomEvent.stopPropagation(event);
      L.DomEvent.preventDefault(event);
      onClose?.();
    };

    closeButton.addEventListener('click', handleCloseClick);

    return () => {
      closeButton.removeEventListener('click', handleCloseClick);
    };
  }, [onClose]);

  const customIcon = L.divIcon({
    className: '',
    iconAnchor: [-10, 24],
    html: ReactDOMServer.renderToString(
      <MarkerContainer background={background}>
        {onClose && (
          <button
            type="button"
            className="marker-map-close"
            aria-label="Fechar marcador"
          >
            ×
          </button>
        )}
        {text && (
          <Text color={color} type="label">
            {text}
          </Text>
        )}
      </MarkerContainer>,
    ),
  });

  return <Marker ref={markerRef} position={position} icon={customIcon} />;
}
